// extracted by mini-css-extract-plugin
module.exports =  {"link":"Integrations__link--hV"};